export default {
	
	/*
	 * 과제/과정명 툴팁 공통 JS
	 * 말줄임(...)이 적용되었는지 여부만 체크
	 * show/hide, 위치 작업은 각 vue 페이지에서 실행
	 **/

	/* 
	 * 말줄임(...) css 적용 여부 체크 height 기준
	 * ProjectContents.vue
	 * DashboardKanban.vue: paperTitle
	 * BoardKanban.vue: paperTitle
	 * Mypage.vue
	 **/
	hasOverflownHeight(element) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.display = 'table';
		element.appendChild(cont);
		res = (cont.offsetHeight > element.offsetHeight);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetHeight, element.offsetHeight);
		// console.log(res);
		element.removeChild(cont);
		return res; 
	},
	/* 
	 * 말줄임(...) css 적용 여부 체크 width 기준
	 * DashboardHeader.vue
	 * DashboardList.vue
	 * DashboardKanban.vue: !paperTitle
	 * BoardKanban.vue: !paperTitle
	 * ProjectFileList.vue
	 * BoardFileList.vue
	 * HomeContents.vue
	 **/
	hasOverflownWidth(element) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.display = 'table';
		element.appendChild(cont);
		res = (cont.offsetWidth > element.offsetWidth);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetWidth, element.offsetWidth);
		// console.log(res);
		element.removeChild(cont);
		return res; 
	},
	/*
	 * 말줄임(...) css 적용 여부 체크 width 기준 (+ padding 값 제거)
	 * BoardLinkProject.vue
	 * BoardList.vue
	 * RegistBoardModal.vue : RegistShareInfoBoard
	 **/
	hasOverflownModalSelectBox(element) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.width = 'auto';
		element.parentElement.appendChild(cont);

		// element의 속성 중 padding 값 제거
		var elemStyle = window.getComputedStyle(element);
		var elemLeftPadding = elemStyle.getPropertyValue('padding-left');
		elemLeftPadding = elemLeftPadding.substring(0, elemLeftPadding.indexOf('px'))
		var elemRightPadding = elemStyle.getPropertyValue('padding-right');
		elemRightPadding = elemRightPadding.substring(0, elemRightPadding.indexOf('px'))
		var textWidth = element.offsetWidth - elemLeftPadding - elemRightPadding;

		res = (cont.offsetWidth > textWidth);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont);
		// console.log(cont.offsetWidth, textWidth);
		// console.log(res);
		element.parentElement.removeChild(cont);
		return res; 
	},
	/*
	 * 말줄임(...) css 적용 여부 체크 height 기준 (+ class 값 제거)
	 * CopyBoardModal.vue
	 * CooperationMemberBoard.vue
	 * ShareInfoBoardManage.vue
	 * SharingBoard.vue
	 * SharingContents.vue
	 * CooperationBoard.vue
	 * CooperationBoardManage.vue
	 * CooperationContents.vue
	 **/
	hasOverflownHeightRemoveClass(element, removeClass) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.minWidth = element.style.width
		if(removeClass != null) {
			cont.classList.remove(removeClass);
		}
		element.parentElement.appendChild(cont);
		res = (cont.offsetHeight > element.offsetHeight);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetHeight, element.offsetHeight);
		// console.log(res);
		element.parentElement.removeChild(cont);
		return res; 
	},
	/* 
	 * 말줄임(...) css 적용 여부 체크 width 기준 (+ class 값 제거, maxWidth 최대)
	 * HomeContents.vue
	 * DashboardList.vue
	 **/
	hasOverflownWidthRemoveClass(element, removeClass) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.minWidth = element.style.width
		cont.style.maxWidth = '1000px';
		if(removeClass != null) {
			cont.classList.remove(removeClass);
		}
		element.parentElement.appendChild(cont);
		res = (cont.offsetWidth > element.offsetWidth);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetWidth, element.offsetWidth);
		// console.log(res);
		element.parentElement.removeChild(cont);
		return res; 
	},
	/* 
	 * 말줄임(...) css 적용 여부 체크 width 기준 (+ append parent)
	 * AllFile.vue
	 * CooperationManage.vue
	 **/
	hasOverflownWidthAppendparent(element) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.display = 'table';
		element.parentElement.appendChild(cont);
		res = (cont.offsetWidth > element.offsetWidth);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetWidth, element.offsetWidth);
		// console.log(res);
		element.parentElement.removeChild(cont);
		return res; 
	},
	/* 
	 * 말줄임(...) css 적용 여부 체크 height 기준 (+ append parent.parent)
	 **/
	hasOverflownHeightAppendparent(element) {
		var res; 
		var cont = element.cloneNode(true);
		cont.style.display = 'table';
		element.parentElement.parentElement.appendChild(cont);
		res = (cont.offsetHeight > element.offsetHeight);
		// console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
		// console.log(cont.offsetHeight, element.offsetHeight);
		// console.log(res);
		// cont.remove();
		element.parentElement.parentElement.removeChild(cont);
		return res; 
	},

	/* bytes 체크 */
	checkTabLength(title, length) {
		let byteLength = length;
		let checkBytes = this.getByteLength(title);
		if(checkBytes != 0) {
			if(checkBytes > byteLength) {
				return true;
			} else {
				return false;
			}
		}
	},
	
	getByteLength(str) {
		if(str == null || str.length == 0) {
			return 0;
		}
		var size = 0;
		for(var i=0; i<str.length; i++) {
			size += this.charByteSize(str.charAt(i));
		}
		return size;
	},
	
	charByteSize(ch) {
		if(ch == null || ch.length == 0) {
			return 0;
		}
		var charCode = ch.charCodeAt(0);
		if (charCode <= 0x00007F) {
			return 1;
		} else if (charCode <= 0x0007FF) {
			return 2;
		} else if (charCode <= 0x00FFFF) {
			return 2;
		} else {
			return 2;
		}
	},

	/* 브라우저 체크: IE의 경우 CSS 다를 수 있음 */
	checkBrowser() {
		let browser;
    let agent = navigator.userAgent.toLowerCase();
    if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) ) {
      browser = "ie";
    }
    else if (agent.indexOf("chrome") != -1) {
      browser = "chrome";
    }

		return browser;
	}
	
}


// WEBPACK FOOTER //
// ./src/components/cowork/common/tooltip/tooltip.js